import { render, staticRenderFns } from "./SelectorTipoGrupoMetodoPagamento.vue?vue&type=template&id=37685078&scoped=true"
import script from "./SelectorTipoGrupoMetodoPagamento.vue?vue&type=script&lang=js"
export * from "./SelectorTipoGrupoMetodoPagamento.vue?vue&type=script&lang=js"
import style0 from "vue-multiselect/dist/vue-multiselect.min.css?vue&type=style&index=0&prod&lang=css&external"
import style1 from "@/vendor/libs/vue-multiselect/vue-multiselect.scss?vue&type=style&index=1&prod&lang=scss&external"
import style2 from "./SelectorTipoGrupoMetodoPagamento.vue?vue&type=style&index=2&id=37685078&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "37685078",
  null
  
)

export default component.exports